import styled from "styled-components";

export const FooterWrapper = styled.div`
  background-color: #0d263b;
`;

export const FooterLine = styled.div`
  background-color: #253b4e;
  height: 1px;
  max-width: 1440px;
  margin-right: auto;
  margin-left: auto;
`;
